import { useQuery } from "@tanstack/react-query";
import { getUsers } from "../../api/apiUsers";
import i18next from "i18next";

export function useGetUser(id) {

    const {
        isLoading,
        data: User,
        error,
    } = useQuery({
        queryKey: ["users", id, i18next.language],
        queryFn: () => getUsers(id),
        retry: false,
    });

    return { isLoading, error, User };
}
